import React from "react";
import { Link } from "react-router-dom";

function FormerHeadmistress() {
  return (
    <>
      {/* Breadcrumb Section */}
      <div className="innerslide py-3 bg-light border-bottom">
        <ul className="breadcrumb container mb-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>

          <li className="breadcrumb-item active">Former Headmistress</li>
        </ul>
      </div>

      {/* Main Content Section */}
      <section className="former-headmistress-section">
        <div className="container">
          <h2 className="section-title text-center mb-5">
            Former Headmistresses
          </h2>

          <div className="row g-4">
            {/* Card 1 */}
            <div className="col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="headmistress-card">
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/A-Rodriques.jpeg"
                  alt="Mrs. A Rodrigues"
                  className="img-fluid headmistress-image"
                />
                <h5 className="mt-3 text-center">Mrs. A Rodrigues</h5>
                <p className="headmistress-tenure text-center">1971 – 1989</p>
              </div>
            </div>

            {/* Card 2 */}
            <div className="col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="headmistress-card">
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/Mrs.Jean_Jones.jpeg"
                  alt="Mrs. Jean Jones"
                  className="img-fluid headmistress-image"
                />
                <h5 className="mt-3 text-center">Mrs. Jean Jones</h5>
                <p className="headmistress-tenure text-center">1989 – 1991</p>
              </div>
            </div>

            {/* Card 3 */}
            <div className="col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="headmistress-card">
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/Mrs.Jennifer_Boward.jpeg"
                  alt="Mrs. Jennifer Boward"
                  className="img-fluid headmistress-image"
                />
                <h5 className="mt-3 text-center">Mrs. Jennifer Boward</h5>
                <p className="headmistress-tenure text-center">1991 – 2002</p>
              </div>
            </div>

            {/* Card 4 */}
            <div className="col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="headmistress-card">
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/Mrs.Catrina_Hastings.jpg"
                  alt="Mrs. Catrina Hastings"
                  className="img-fluid headmistress-image"
                />
                <h5 className="mt-3 text-center">Mrs. Catrina Hastings</h5>
                <p className="headmistress-tenure text-center">2002 – 2024</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default FormerHeadmistress;
